import { Locale } from '../types/locale';

export const EN_US_LOCALE: Locale = {
  locale: 'en-US',

  // General
  general: {
    increase: 'Increase',
    decrease: 'Decrease',
    root: 'Root',
  },

  // Plot Components
  /** statistic text component */
  statistic: {
    total: 'Total',
  },
  /** conversionTag component */
  conversionTag: {
    label: 'Conversion rate',
  },
  legend: {},
  tooltip: {},
  slider: {},
  scrollbar: {},

  // Plots
  waterfall: {
    total: 'Total',
  },
};
